let Backbone = require("backbone");

let main = function(Backbone){
    return Backbone.Model.extend({
        initialize: function(params) {
            if(!params.viewHeight) {
                throw Error('missing viewHeight');
            }

            if(!params.rowSize) {
                throw Error('missing rowSize');
            }

            if(!params.itemSize) {
                this.set({itemSize: 0});
            }

            this.set({pageSize: Math.floor(Math.floor(params.viewHeight)/params.rowHeight)*Math.floor(params.rowSize)});
            this.set({maxPage: Math.ceil(params.itemSize/this.get('pageSize'))});
            this.set({rowPerPage: Math.ceil(params.itemSize/this.get('pageSize'))});
        },

        pageUp: function() {
            var current = this.get('currentPage');

            if(current>0) {
                this.set({currentPage:current-1});
            }
        },

        pageDown: function() {
            var current = this.get('currentPage');

            if(current<this.get('maxPage')-1) {
                this.set({currentPage:current+1});
            }
        },

        toLastPage: function(){
            this.set({currentPage: (this.get('maxPage')-1)});
        },


        /**
         * this method should be called when you are adding element to
         * a page after the first render. This is trigger event to recalculate and redraw the page
         * @param itemSize
         */
        setItemSize: function(itemSize) {
            this.set({itemSize: itemSize});
            this.set({maxPage: Math.ceil(itemSize/this.get('pageSize'))});
            this.set({rowPerPage: Math.ceil(itemSize/this.get('pageSize'))});
        }
    });
};

let exportedValue = main(Backbone);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/PagingModel.js